"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const draftster_core_1 = __importDefault(require("../../../components/draftster_core"));
const draftster_1 = require("../../../client/draftster");
const styles_css_1 = __importDefault(require("./styles.css"));
const c = { draftster: `${styles_css_1.default.draftster}` };
const DraftEditor = ({ form, giveaway, draftRef, pendingChanges, setIsSubmitting, field, }) => {
    const config = {
        className: c.draftster,
        // The editor will fire this to report newly made changes since the last save. (By init content or getEditorContent)
        editorWasUpdated() {
            pendingChanges.add(field);
        },
        handleImageUpload(image, callback) {
            return (0, draftster_1.uploadImageToServer)(image)
                .then((mergedImage) => callback(null, mergedImage))
                .catch((err) => callback(err, image));
        },
        // This is specific to image uploads in Draftster. It will get called on any image upload or paste event when
        // images exist in the buffer.
        isEditorBusy(bool) {
            setIsSubmitting(bool);
        },
        processImage(image) {
            return (0, draftster_1.processRemoteImage)(image);
        },
        setInitialContent() {
            return (0, draftster_1.prepareModelForDraftsterInstance)(form[field] || giveaway[field]);
        },
        toolbar: {
            carousel: false,
            linkedImage: true,
        },
    };
    return react_1.default.createElement(draftster_core_1.default, { ref: (el) => (draftRef.current = el), config: config });
};
exports.default = DraftEditor;
